import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Typography, Card, Flex, Form, InputNumber, Select, Input, Modal, Upload, Tabs, Space, DatePicker, Divider, Tooltip, Row, Col, Empty } from 'antd';
import PageHeader from '../../view/pageheader';
import { DownloadOutlined, PlusOutlined, SaveOutlined, UploadOutlined, SearchOutlined, PrinterOutlined, FileOutlined, EditOutlined, ReloadOutlined, DeleteOutlined, EyeInvisibleOutlined, EyeFilled } from '@ant-design/icons';
import { prepQueueById, addExcelPrepProcess, updatePrepProcessData, prepQueueByIdCompletd, deleteBoxUniqueIDWeareHouseData, getDeletedBoxUniqueID, addFileType } from "../../store/reducer/prepQueueSlice";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from 'react-toastify'
import { FileAllType } from '../../store/reducer/prepQueueSlice';
import TableComponent from '../CustomComponents/TableComponent';
import TextAreaInput from '../CustomComponents/TextAreaInput';
import { getCustomerList } from "../../store/reducer/customerSlice";
// import moment from "moment-timezone";
import Loader from '../../fields/Loader/Loader';
import SearchComponent from '../CustomComponents/SearchComponent';
import dayjs from 'dayjs';
import moment from 'moment';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
const { TabPane } = Tabs;
const { Title } = Typography;
const App = () => {
  const { id } = useParams();
  console.log(id, "id from params");
  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      query: params.get("query") || "",
      pickup_date: params.get("pickup_date") || "",
    };
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [form] = Form.useForm();
  const [preprocessingQueueData, setPreprocessingQueueData] = useState([]);
  const [completedPreprocessingQueueData, setCompletedPreprocessingQueueData] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [jobData, setJobData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [completedOrginalData, setCompletedOrginalData] = useState([]);
  const { prepQueueByIdData, completedPrepQueueByIdData, addExcelPrepProcessError, addExcelPrepProcessErrorMessage, prepTeamQueueLoading, addFileTypeSucess, addFileError, addFileErrorMessage, deleteBoxUniqueIDWeareHouseDataSuccess, getDeletedBoxUniqueIDData } = useSelector((state) => state.prepTeamQueue);
  const [pendingPayload, setPendingPayload] = useState(null);
  const { customerListData } = useSelector((state) => state.customers);
  const { AllFileData } = useSelector((state) => state.prepTeamQueue);
  const { jobListData } = useSelector((state) => state.jobs);
  const userId = localStorage.getItem('user_id');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [modifiedRows, setModifiedRows] = useState(new Set());
  const [completedModifiedRows, setCompletedModifiedRows] = useState(new Set());
  const [fileData, setFileData] = useState([])
  const [activetab, setActiveTab] = useState("1")
  const [searchModal, setSearchModal] = useState(false)
  const [searchText, setSearchText] = useState('');
  const [searchDate, setSearchDate] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const role_id = localStorage.getItem("role_id");
  const [fileModal, setFileModal] = useState(false)
  const [addFileMOdal, setAddFileModal] = useState(false)
  const [editingFileType, setEditingFileType] = useState(null);
  const [isEditingFile, setIsEditingFile] = useState(false);
  const [clearData, setClearData] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { count: counts, data: tableFileData } = AllFileData
  const { count: deletedCounts, data: deletedTableData } = getDeletedBoxUniqueIDData;
  console.log(deletedTableData, "deletedTableData==");

  function getAllData(payload = {}) {
    const editId = window.atob(id);
    dispatch(getJobsList(payload))
    dispatch(FileAllType(payload))
    dispatch(getCustomerList(payload))
    dispatch(getDeletedBoxUniqueID({ editId, ...payload }))

  }
  function getData(payload = {}) {
    if (id) {
      getAllData()
      const editId = window.atob(id);
      const assign_user_id = localStorage.getItem('user_id');
      if (activetab == '1') {

        // dispatch(clearCompletedPrepQueueByIdData());
        const query = payload.query
        const pickup_date = payload.pickup_date;
        dispatch(prepQueueById({ editId, assign_user_id, query, pickup_date, ...payload }));
      } else if (activetab == '2') {

        // dispatch(clearPrepQueueByIdData());
        const query = payload.query
        const pickup_date = payload.pickup_date;
        dispatch(prepQueueByIdCompletd({ editId, query, pickup_date, assign_user_id, payload }));
      }

    }

  }
  const {
    control: fileControl,
    setValue: setFileValue,
    handleSubmit: handleFileSubmit,
    formState: { errors: fileErrors },
    reset: rest
  } = useForm({
    resolver: yupResolver(yup.object().shape({
      file_type: yup.string().trim().required("File Type is required")
    })),
    mode: "onChange",
  });
  const handleSearch = () => {
    const payloadData = {
      query: searchText,
    };


    // Add pickup_date only if selected
    if (searchDate) {
      payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
    }
    getData(payloadData);
    setSearchModal(false)
    setSearchDate(null)
    setSearchText('');
    setClearData(true);

  };
  const clearFilterData = () => {
    setClearData(false);
    getData({});

  }
  useEffect(() => {
    const { query, pickup_date } = getQueryParams();

    const payload = {};
    if (query && query.trim() !== "") {
      setSearchText(query.trim());
      payload.query = query.trim();
    }

    if (pickup_date) {
      setSearchDate(pickup_date); // keep as string if backend expects MM/DD/YYYY
      payload.pickup_date = pickup_date;
    }

    if (payload.query || payload.pickup_date) {
      setPendingPayload(payload);
      setActiveTab("2");
    } else {
      setPendingPayload({});
      setActiveTab(id === "all" ? "2" : "1");
    }
  }, [id, location.search]);




  useEffect(() => {
    if (id && activetab && pendingPayload !== null) {
      getData(pendingPayload);
    }
  }, [id, activetab, pendingPayload]);
  useEffect(() => {
    let formattedData1 = [];
    if (activetab == '1' && Array.isArray(prepQueueByIdData)) {

      formattedData1 = prepQueueByIdData.map((item, index) => ({
        ...item,
        key: index.toString(),
      }));
    }
    if (formattedData1.length > 0) {
      setPreprocessingQueueData(formattedData1);
      setOriginalData(JSON.stringify(formattedData1));
    }
  }, [prepQueueByIdData, activetab == '1']);

  useEffect(() => {

    let formattedData2 = [];


    if (activetab == '2' && Array.isArray(completedPrepQueueByIdData)) {
      formattedData2 = completedPrepQueueByIdData.map((item, index) => ({
        ...item,
        key: index.toString(),
      }));
    }


    if (formattedData2.length > 0) {
      setCompletedPreprocessingQueueData(formattedData2);
      setCompletedOrginalData(JSON.stringify(formattedData2));

    }
    if (jobListData?.data) {
      setJobData(jobListData.data);
    }

    if (AllFileData?.data) {
      setFileData(AllFileData.data);
    }

    if (customerListData?.data) {
      setCustomerList(customerListData.data);
    }
  }, [completedPrepQueueByIdData, jobListData, AllFileData, customerListData, activetab]);
  const specIdData = useMemo(() => {
    if (!preprocessingQueueData.length || !jobData.length) return [];
    return jobData
      .map((item) => ({
        label: item?.spec_id,
        value: item?.id,
        workflow_id: item?.workflow_id,
        customer_id: item?.customer_id,
        customer_name: item?.customer?.customername
      }));
  }, [jobData, preprocessingQueueData]);


  const customerLists = useMemo(() => {
    if (!customerList.length) return [];
    return customerList
      .filter((customer) => customer.status == 1)
      .map((item) => ({
        label: item.customername,
        value: item.id,
      }));
  }, [customerList]);
  const fileDatas = useMemo(() => {

    return fileData
      .map((item) => ({
        label: item?.file_type,
        value: item?.id,

      }));
  }, [fileData]);
  const handleDownloadBarcodeExcel = () => {
    if (selectedRowKeys.length == 0) {
      toast.error("Please select at least one row to download the barcode Excel file.");
      return;
    }
    const tableData = selectedRowKeys.map(
      ({
        box_unique_id, customer_box_id, spec, file_type, pickup_date
      }) => ({
        'Unique ID': box_unique_id,




        // 'Address': address,
        // 'Aisle': aisle,
        // 'Level': level,
        // 'Bay': bay,
        // 'From': from,
        // Important: Use JS Date objects so Excel recognizes them as dates
        // 'Pickup Date (mm/dd/yyyy)': pickup_date ? moment(pickup_date).format("MM/DD/YYYY") : null,
        // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,
      })
    );

    // Create headers
    const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

    // Get max length to iterate safely
    const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

    const customerMap = {};
    customerList.forEach(customer => {
      customerMap[customer.id] = customer.customername;
    });

    // Generate the combined data
    for (let i = 0; i < maxLength; i++) {
      const specId = specIdData[i]?.label ?? '';
      const customerId = specIdData[i]?.customer_name ?? '';
      const fileType = fileDatas[i]?.label ?? '';

      const customerName = customerMap[customerId] || '';
      const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

      combinedSheetData.push([specWithCustomer, fileType || '']);
    }

    const ws1 = XLSX.utils.json_to_sheet(tableData);
    const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
    const colWidth1 = 25;
    ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
    const colWidth2 = 30;
    ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');


    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'unique_id_label.xlsx');
    setSelectedRowKeys([])
  };

  const handleDownloadExcel = () => {
    let tableData = [];

    if (activetab == '1') {
      tableData = preprocessingQueueData.map(
        ({
          box_unique_id, customer_box_id, spec, file_types, address, aisle, bay,
          from, left_warehouse, level, pickup_date, customer_id
        }) => ({
          'Unique ID': box_unique_id,
          'Customer Box ID': customer_box_id,
          'Customer Name': customer_id ? customerList.find((customer) => customer.id === customer_id)?.customername : null,
          'Spec ID': spec ? Number(spec) : null,
          'File Type': file_types?.file_type,

          // 'Address': address,
          // 'Aisle': aisle,
          // 'Level': level,
          // 'Bay': bay,
          // 'From': from,
          // Important: Use JS Date objects so Excel recognizes them as dates
          'Pickup Date (mm/dd/yyyy)': pickup_date ? moment(pickup_date).format("MM/DD/YYYY") : null,
          // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,
        })
      );
    } else {
      tableData = completedPreprocessingQueueData.map(
        ({
          box_unique_id, customer_box_id, spec, file_types, address, aisle, bay,
          from, left_warehouse, level, pickup_date, customer_id
        }) => ({
          'Unique ID': box_unique_id,
          'Customer Box ID': customer_box_id,

          'File Type': file_types?.file_type,

          // 'Address': address,
          // 'Aisle': aisle,
          // 'Level': level,
          // 'Bay': bay,
          // 'From': from,
          // Important: Use JS Date objects so Excel recognizes them as dates
          'Pickup Date (mm/dd/yyyy)': pickup_date ? moment(pickup_date).format("MM/DD/YYYY") : null,
          // 'Left Warehouse (mm/dd/yyyy)': left_warehouse ? moment(left_warehouse).format("MM/DD/YYYY") : null,
        })
      );
    }
    const ws1 = XLSX.utils.json_to_sheet(tableData);
    const colWidth1 = 25;
    ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');

    if (activetab == '1') {
      const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

      const customerMap = {};
      customerList.forEach(customer => {
        customerMap[customer.id] = customer.customername;
      });

      // Build spec-customer pairs
      const specCustomerPairs = specIdData.map(spec => ({
        spec_id: spec.label,
        customer_name: spec.customer_name,
      }));

      // Build a set of customer names that already have a spec assigned
      const customersWithSpec = new Set(specCustomerPairs.map(sc => sc.customer_name));

      // Find customers without spec
      const customersWithoutSpec = customerList.filter(
        (customer) => !customersWithSpec.has(customer.customername)
      );

      // Combine spec-customer rows + customers-without-spec rows
      const combinedData = [
        ...specCustomerPairs.map(({ spec_id, customer_name }) => ({
          specWithCustomer: `${spec_id} - ${customer_name}`,
          fileType: '',
        })),
        ...customersWithoutSpec.map((customer) => ({
          specWithCustomer: `No Spec - ${customer.customername}`,
          fileType: '',
        })),
      ];

      // Add File Type column values if available
      const maxLength = Math.max(combinedData.length, fileDatas.length);
      for (let i = 0; i < maxLength; i++) {
        const specWithCustomer = combinedData[i]?.specWithCustomer || '';
        const fileType = fileDatas[i]?.label || '';
        combinedSheetData.push([specWithCustomer, fileType]);
      }

      // Write to sheet
      const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
      ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: 30 }));
      XLSX.utils.book_append_sheet(wb, ws2, 'Reference Sheet');
    }

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'Preprocessing_Queue.xlsx');
  };
  const excelDateToJSDate = (serial) => {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400; // seconds in a day
    const date_info = new Date(utc_value * 1000); // convert to ms
    return moment(date_info).format("MM/DD/YYYY");
  };


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFileList([]);
  };

  const handleUpload = async () => {
    const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
    if (!fileList.length) {
      toast.error("Please select an Excel file to upload!");
      return;
    }

    const file = fileList[0];
    const fileName = file.name;
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error("Invalid file type! Please upload a valid Excel file.");
      return;
    }
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet)
      // const allowedSpecIds = specIdData.map((item) => item.label);
      let hasErrors = false;
      if (jsonData.length > (activetab == '1' ? preprocessingQueueData.length :
        completedPreprocessingQueueData.length)) {
        toast.error("You have uploaded more records than allowed!");
        hasErrors = true;
      }


      jsonData.forEach((row, index) => {
        if (!row["Unique ID"]) {
          toast.error(`Row ${index + 1}: Missing required fields.`);
          hasErrors = true;
        }
        if (row["Pickup Date (mm/dd/yyyy)"] && typeof row["Pickup Date (mm/dd/yyyy)"] === "number") {
          row["Pickup Date (mm/dd/yyyy)"] = excelDateToJSDate(row["Pickup Date (mm/dd/yyyy)"]);
        }

        if (row["Left Warehouse (mm/dd/yyyy)"] && typeof row["Left Warehouse (mm/dd/yyyy)"] === "number") {
          row["Left Warehouse (mm/dd/yyyy)"] = excelDateToJSDate(row["Left Warehouse (mm/dd/yyyy)"]);
        }
      });

      jsonData.includes(jsonData)

      if (!hasErrors) {
        const specWorkflowMap = specIdData.reduce((map, item) => {
          map[item.label] = item.workflow_id;
          return map;
        }, {});

        // Add workflow_id to each row in jsonData
        const processedData = jsonData.map(row => ({
          ...row,
          workflow_id: row["Spec ID"] ? specWorkflowMap[row["Spec ID"]] : null
        }));
        const postData = {
          jsonData: processedData,
          customer_id: preprocessingQueueData[0]?.customer_id,
          assign_user_id: userId,
          prep_queue_id: atob(id),
          updated_user_id: Number(localStorage.getItem('user_id')),
          activetab: activetab,
          preprocess_id: window.atob(id),
          file_name: fileName
        }
        dispatch(addExcelPrepProcess({ postData }))
        setUploadModalVisible(true);
        setFileList([]);
        setIsModalOpen(false)

      }
    };

    reader.readAsArrayBuffer(file);
  };
  useEffect(() => {
    if (addFileError) {
      toast.error(addFileErrorMessage);
      return; // Prevents running success block in case both are truthy by mistake
    }

    if (addFileTypeSucess) {
      toast.success(`FileType ${isEditingFile ? 'Updated' : 'Added'} Successfully`);
      getData();
    }
  }, [addFileTypeSucess, addFileError, addFileErrorMessage]);
  useEffect(() => {
    if (deleteBoxUniqueIDWeareHouseDataSuccess) {
      toast.success("Unique ID Deleted Successfully")
      getData({})
    }
  }, [deleteBoxUniqueIDWeareHouseDataSuccess])

  const inputRef = useRef(null);
  useEffect(() => {
    if (addFileMOdal) {

      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [addFileMOdal]);
  const onSubmitFile = (data) => {
    const payload = {
      postData: {
        file_type: data.file_type,
        ...(isEditingFile && { id: editingFileType.id }) // Include ID if editing
      }
    };
    dispatch(addFileType({ postData: payload }))
      .then(() => {
        // toast.success(`FileType ${isEditingFile ? 'Updated' : 'Added'} Successfully`);
        handleAddFileClose();
        rest();
        setEditingFileType(null);
        setIsEditingFile(false);
      });
  };
  const handleClose = () => {
    setFileModal(false)
  }
  const handleAddFileSubmit = () => {
    handleFileSubmit(onSubmitFile)();
    rest();
  };
  const handleAddFileClose = () => {
    setAddFileModal(false);
    setEditingFileType(null);
    setIsEditingFile(false);
    rest();
  }
  useEffect(() => {
    if (id) {
      try {
        const editId = window.atob(id)
        const assign_user_id = localStorage.getItem("user_id");

        if (assign_user_id) {
          dispatch(prepQueueById({ editId, assign_user_id }));
          // toast.success("Excel Prep Process Success");
          setIsModalOpen(false);
        } else {
          console.error("User ID not found in localStorage");
        }
      } catch (error) {
        console.error("Invalid base64 ID:", error);
      }
    }

    // if (addExcelPrepProcessError) {
    //   toast.error(addExcelPrepProcessErrorMessage || "An error occurred.");
    //   dispatch(resetSuccessFlag({ flag: "addExcelPrepProcessError" }));
    // }
  }, [dispatch, id, setIsModalOpen]);
  // const disabledData=preprocessingQueueData.filter((data)=>data.allocated==1)



  const columns = [
    {
      title: 'Unique ID',
      dataIndex: 'box_unique_id',
      key: 'box_unique_id',
      width: '25%',
    },
    {
      title: 'Customer Box ID',
      dataIndex: 'customer_box_id',
      key: 'customer_box_id',
      width: '35%',
      render: (text, record) => (
        <InputNumber style={{ width: '200px' }}
          value={record.customer_box_id}
          placeholder='Enter Box ID'
          // disabled={record.customer_box_id}
          onChange={(value) => {
            const newData = [...preprocessingQueueData];
            const index = newData.findIndex((item) => item.key == record.key);
            if (index > -1) {
              newData[index] = { ...record, customer_box_id: value };
              setPreprocessingQueueData(newData);
              setModifiedRows(prev => new Set(prev.add(record.key)));
            }
          }}
        />
      ),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: '40%',
      render: (text, record) => (
        <>

          <Select
            style={{ width: '100%' }}
            options={customerLists}
            value={record.customer_name}
            placeholder='Select Customers Name'
            disabled={record?.is_saved == 1}
            onChange={(value) => {
              const selectedCustomer = customerLists.find((item) => item.value === value);
              const newData = [...preprocessingQueueData];
              const index = newData.findIndex((item) => item.key === record.key);

              if (index > -1) {
                newData[index] = {
                  ...record,
                  customer_id: selectedCustomer?.value || null,
                  customer_name: selectedCustomer?.label || '',
                  spec: null,
                  spec_id: null,
                  workflow_id: null,
                };

                setPreprocessingQueueData(newData);
                setModifiedRows((prev) => new Set(prev.add(record.key)));
              }
            }}
          />

        </>
      ),
    },
    {
      title: (<span> Spec ID <span style={{ color: 'red' }}>*</span>
      </span>
      ),
      dataIndex: 'spec',
      key: 'spec',
      width: '40%',
      render: (text, record) => {
        // Dynamically filter spec options based on the current row's customer_id
        const specOptions = jobData
          .filter((item) => item.customer_id == record.customer_id)
          .map((item) => ({
            label: item.spec_id,
            value: item.id,
            // workflow_id: item.workflow_id,
          }));

        return (
          <Select
            showSearch
            style={{ width: '100%' }}
            options={specOptions}
            value={record.spec}
            placeholder='Select Spec ID'
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label?.toLowerCase().includes(input.toLowerCase())
            }
            disabled={record?.is_saved == 1}
            onChange={(value) => {
              const selectedSpec = specOptions.find((item) => item.value === value);
              const newData = [...preprocessingQueueData];
              const index = newData.findIndex((item) => item.key === record.key);
              if (index > -1) {
                newData[index] = {
                  ...record,
                  spec: selectedSpec.label,
                  spec_id: selectedSpec.value,
                  workflow_id: selectedSpec.workflow_id,
                };
                setPreprocessingQueueData(newData);
                setModifiedRows((prev) => new Set(prev.add(record.key)));
              }
            }}
          />
        );
      },
    },


    {
      title: 'File Type',
      dataIndex: 'file_type',
      key: 'file_type',
      width: '40%',
      render: (text, record) => (
        <Select
          style={{ width: '100%' }}
          options={fileDatas}
          value={record.file_type} // this should be the value
          placeholder="Select File Type"
          disabled={record.allocated === 1}
          onChange={(value) => {
            const selectedFile = fileDatas.find(item => item.value === value);
            if (!selectedFile) return;

            const updatedData = [...preprocessingQueueData];
            const index = updatedData.findIndex(item => item.key === record.key);

            if (index !== -1) {
              updatedData[index] = {
                ...updatedData[index],
                file_type: selectedFile.value, // store value only
              };
              setPreprocessingQueueData(updatedData);
              setModifiedRows(prev => new Set(prev).add(record.key));
            }
          }}
        />
      ),
    },
    {
      title: (<span> Box Pickup Date <span style={{ color: 'red' }}></span>
      </span>
      ),
      dataIndex: 'pickup_date',
      key: 'pickup_date',
      render: (text, record) => (
        <DatePicker
          format="MM/DD/YYYY"
          style={{ width: '200px' }}
          value={record.pickup_date ? dayjs(record.pickup_date) : null} // ensure moment object
          placeholder="Enter Pickup Date"
          onChange={(date) => {
            const newData = [...preprocessingQueueData];
            const index = newData.findIndex((item) => item.key === record.key);
            if (index > -1) {
              newData[index] = {
                ...record,
                pickup_date: date ? dayjs(date).format('MM/DD/YYYY') : null, // format to MM/DD/YYYY
              };
              setPreprocessingQueueData(newData);
              setModifiedRows((prev) => new Set(prev.add(record.key)));
            }
          }}
          allowClear
        />
      ),
    },

  ];
  const completedcolumns = [
    {
      title: 'Unique ID',
      dataIndex: 'box_unique_id',
      key: 'box_unique_id',
      width: '25%',
    },
    {
      title: 'Customer Box ID',
      dataIndex: 'customer_box_id',
      key: 'customer_box_id',
      width: '35%',
      render: (text, record) => (
        <InputNumber style={{ width: '200px' }}
          value={record.customer_box_id}
          placeholder='Enter Box ID'
          // disabled={record.customer_box_id}
          onChange={(value) => {
            const newData = [...completedPreprocessingQueueData];
            const index = newData.findIndex((item) => item.key == record.key);
            if (index > -1) {
              newData[index] = { ...record, customer_box_id: value };
              setCompletedPreprocessingQueueData(newData);
              setCompletedModifiedRows(prev => new Set(prev.add(record.key)));
            }
          }}
        />
      ),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_id',
      key: 'customer_id',
      width: '40%',
      render: (text, record) => (
        <Select
          style={{ width: '100%' }}
          options={customerLists}
          value={record.customer_id}
          placeholder='Select Customers Name'
          disabled={record?.is_saved == 1}
          onChange={(value) => {
            const selectedSpec = customerLists.find((item) => item.value == value);
            const newData = [...completedPreprocessingQueueData];
            const index = newData.findIndex((item) => item.key === record.key);
            if (index > -1) {
              newData[index] = { ...record, customer_id: selectedSpec.value, customer_name: selectedSpec.label };
              setCompletedPreprocessingQueueData(newData);
              setCompletedModifiedRows(prev => new Set(prev.add(record.key)));
            }
          }}
        />
      ),
    },
    {
      title: 'Spec ID',
      dataIndex: 'spec',
      key: 'spec',
      width: '40%',
      render: (text, record) => {
        // Dynamically filter spec options based on the current row's customer_id
        const specOptions = jobData
          .filter((item) => item.customer_id == record.customer_id)
          .map((item) => ({
            label: item.spec_id,
            value: item.id,
            // workflow_id: item.workflow_id,
          }));

        return (
          <Select
            style={{ width: '100%' }}
            options={specOptions}
            value={record.spec}
            placeholder='Select Spec ID'
            disabled={record?.is_saved == 1}
            onChange={(value) => {
              const selectedSpec = specOptions.find((item) => item.value === value);
              const newData = [...completedPreprocessingQueueData];
              const index = newData.findIndex((item) => item.key === record.key);
              if (index > -1) {
                newData[index] = {
                  ...record,
                  spec: selectedSpec.label,
                  spec_id: selectedSpec.value,
                  workflow_id: selectedSpec.workflow_id,
                };
                setCompletedPreprocessingQueueData(newData);
                setCompletedModifiedRows((prev) => new Set(prev.add(record.key)));
              }
            }}
          />
        );
      },
    },


    {
      title: 'File Type',
      dataIndex: 'file_type',
      key: 'file_type',
      width: '40%',
      render: (text, record) => (
        <Select
          style={{ width: '100%' }}
          options={fileDatas}
          value={record.file_type} // this should be the value
          placeholder="Select File Type"
          disabled={record.allocated === 1}
          onChange={(value) => {
            const selectedFile = fileDatas.find(item => item.value === value);
            if (!selectedFile) return;

            const updatedData = [...completedPreprocessingQueueData];
            const index = updatedData.findIndex(item => item.key === record.key);

            if (index !== -1) {
              updatedData[index] = {
                ...updatedData[index],
                file_type: selectedFile.value, // store value only
              };
              setCompletedPreprocessingQueueData(updatedData);
              setCompletedModifiedRows(prev => new Set(prev).add(record.key));
            }
          }}
        />
      ),
    },
    {
      title: (<span> Box Pickup Date <span style={{ color: 'red' }}>*</span>
      </span>
      ),
      dataIndex: 'pickup_date',
      key: 'pickup_date',
      render: (text, record) => (
        <DatePicker
          format="MM/DD/YYYY"
          style={{ width: '200px' }}
          value={record.pickup_date ? dayjs(record.pickup_date) : null} // ensure moment object
          placeholder="Enter Pickup Date"
          onChange={(date) => {
            const newData = [...completedPreprocessingQueueData];
            const index = newData.findIndex((item) => item.key === record.key);
            if (index > -1) {
              newData[index] = {
                ...record,
                pickup_date: date ? dayjs(date).format('MM/DD/YYYY') : null,// format to MM/DD/YYYY
              };
              setCompletedPreprocessingQueueData(newData);
              setCompletedModifiedRows((prev) => new Set(prev.add(record.key)));
            }
          }}
          allowClear
        />
      ),
    },

  ];
  const fileTypeColumns = [
    {
      title: "Serial No",
      dataIndex: "file_type", // Ensure the correct key
      key: "file_type",
      render: (_, record, index) => index + 1,
      align: "center",
    },
    {
      title: "File Type",
      dataIndex: "file_type", // Ensure the correct key
      key: "file_type",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      render: (data) => (
        <>
          <Tooltip title="Edit">
            <Button
              shape="circle"
              className="border-0"
              icon={<EditOutlined style={{ color: "blue" }} />}

              onClick={() => {
                setEditingFileType(data);
                setIsEditingFile(true);
                setAddFileModal(true);
                setFileValue("file_type", data.file_type); // Pre-populate the form
              }}
            />

          </Tooltip>
        </>

      ),
    }
  ]

  const deletedColumns = [
    {
      title: "Unique ID ",
      dataIndex: "box_unique_id",
      key: "box_unique_id",
      align: 'center',
      // width: "80%",
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      render: (text) => (text ? text : 'N/A'),
      align: 'center',
    },
    {
      title: "Pickup Date",
      dataIndex: "pickup_date",
      key: "pickup_date",
      render: (text) => (text ? text : 'N/A'),
      align: 'center',
    },
    {
      title: "Deleted Date",
      dataIndex: "deleted_at",
      key: "deleted_at",
    },


  ];
  const onSelectChange = (newSelectedRowKeys, newRow) => {
    setSelectedRowKeys(newRow);
  };
  const rowSelection = {
    onChange: onSelectChange,

    getCheckboxProps: record => ({
      // disabled: record.spec == null, // Example: disable row based on data
    }),
  };
  const handleSaveData = (_, actionType) => {
    const isPagination = actionType === "pagination";
    if (activetab == '1') {
      if (originalData.length == 0 || !preprocessingQueueData.length) {
        toast.error("No data to sav1e!");
        return;
      }

    }
    else if (activetab == '2') {
      if (completedOrginalData.length == 0 || !completedPreprocessingQueueData.length) {
        toast.error("No data to save!");
        return;
      }
    }
    if (activetab == '1') {
      const parsedOriginalData = JSON.parse(originalData); // Parse original data from string
      const updatedData = preprocessingQueueData.filter((item) => {
        const originalItem = parsedOriginalData.find((orig) => orig.key === item.key);
        return JSON.stringify(originalItem) !== JSON.stringify(item); // Compare original with updated
      });

      if (updatedData.length === 0) {
        if (!isPagination) toast.info("No changes detected.");
        return;
      }
      const modifiedData = updatedData.filter((item) => modifiedRows.has(item.key));
      const invalidRows = modifiedData.filter(
        (item) => item.spec_id && !item.pickup_date
      );


      // if (invalidRows.length > 0) {
      //   toast.error("Pickup Date is required when Spec ID is selected!");
      //   return;
      // }
      const postData = {
        updatedData: modifiedData,
        customer_id: preprocessingQueueData[0]?.customer_id,
        assign_user_id: userId,
        prep_queue_id: atob(id),
        updated_user_id: Number(localStorage.getItem('user_id')),
        activetab: activetab,
        preprocess_id: window.atob(id),
      }
      dispatch(updatePrepProcessData({ postData }))
        .unwrap() // Handle the promise returned by the thunk
        .then(() => {
          // On successful save, re-fetch the updated data
          const editId = atob(id);
          const assign_user_id = localStorage.getItem('user_id');
          window.location.reload();
          dispatch(prepQueueById({ editId, assign_user_id }))
            .then(() => {
              toast.success("Data saved successfully!");
              setModifiedRows(new Set());
            });
        })
        .catch((error) => {
          toast.error("Please Select Spec ID ")
        });

    } else if (activetab == '2') {
      const parsedOriginalData = JSON.parse(completedOrginalData); // Parse original data from string
      const updatedData = completedPreprocessingQueueData.filter((item) => {
        const originalItem = parsedOriginalData.find((orig) => orig.key === item.key);
        return JSON.stringify(originalItem) !== JSON.stringify(item); // Compare original with updated
      });
      if (updatedData.length === 0) {
        if (!isPagination) toast.info("No changes detected.");
        return;

      }
      const modifiedData = updatedData.filter((item) => completedModifiedRows.has(item.key));
      // const modifiedData = updatedData.filter((item) => modifiedRows.has(item.key));
      const invalidRows = modifiedData.filter(
        (item) => item.spec_id && !item.pickup_date
      );


      // if (invalidRows.length > 0) {
      //   toast.error("Pickup Date is required when Spec ID is selected!");
      //   return;
      // }
      const postData = {
        updatedData: modifiedData,
        customer_id: preprocessingQueueData[0]?.customer_id,
        assign_user_id: userId,
        prep_queue_id: atob(id),
        updated_user_id: Number(localStorage.getItem('user_id')),
        activetab: activetab,
        preprocess_id: window.atob(id),
      }
      dispatch(updatePrepProcessData({ postData }))
        .unwrap() // Handle the promise returned by the thunk
        .then(() => {
          // On successful save, re-fetch the updated data
          const editId = atob(id);
          const assign_user_id = localStorage.getItem('user_id');
          dispatch(prepQueueById({ editId, assign_user_id }))
            .then(() => {
              toast.success("Data saved successfully!");
              setCompletedModifiedRows(new Set());
            });
        })
        .catch((error) => {
          toast.error("Please Select Spec ID ")
        });
    }

  };
  const handleDeleteUniueID = () => {
    if (selectedRowKeys.length === 0) {
      toast.dismiss()
      return toast.error("Please select at least one row");
    }

    // SweetAlert confirmation
    Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the selected Box Unique IDs.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Prepare data for API
        const data = selectedRowKeys.map((item) => ({
          box_unique_id: item.box_unique_id,
          ...(activetab === "2" && { barcode: item.barcode }), // include only for tab 2
        }));

        const postData = {
          ...data,
          activetab: '1',
          ...(activetab == "2" && { type: 'spec-assigned' })
        }


        // Dispatch delete action
        dispatch(deleteBoxUniqueIDWeareHouseData({ postData }));

        // Swal.fire("Deleted!", "The selected items have been deleted.", "success");
      }
    });
  };
  const handleTabChange = (key) => {
    navigate(`?tab=${key}`);
    window.location.reload(); // 🔁 reloads page showing same tab
  };

  //  On page load, read tab from URL
  useEffect(() => {
    const urlTab = params.get("tab");
    if (urlTab) {
      setActiveTab(urlTab);
    }
  }, [location.search]);
  return (
    <>
      <Loader loading={prepTeamQueueLoading} />
      <PageHeader
        HeaderText="Review & Edit Boxes"
        Breadcrumb={[{ name: "Review & Edit Boxes" }]}
        backButtonUrl="/prep-queue"
      />
      <Tabs activeKey={activetab} onChange={handleTabChange} type="card">
        <TabPane tab="Awaiting Review Boxes" key="1">
          <Card
            // title="Review & Update Boxes"
            extra={
              <Flex justify="space-between" align="center" style={{ width: "100%", flexWrap: "wrap", marginTop: '20px' }}>
                <div>
                  <Button
                    style={{ backgroundColor: '#1e90a9' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<PrinterOutlined />}
                    onClick={handleDownloadBarcodeExcel}
                  >
                    Export Unique ID Label
                  </Button>

                  <Button
                    style={{ backgroundColor: '#da7e22ff' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={handleDownloadExcel}
                  >
                    Download Template
                  </Button>

                  <Button
                    style={{ backgroundColor: '#7e0e0eff' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => showModal()}
                  >
                    Upload Excel
                  </Button>



                  {role_id != 3 && (
                    <Button
                      style={{ backgroundColor: '#96743e', color: 'white' }}
                      icon={<FileOutlined />}
                      className="rounded-5 ml-1"
                      onClick={() => setFileModal(true)}
                    >
                      Document File Types
                    </Button>
                  )}
                </div>

                {/* Second line with Search + Clear */}
                <div style={{ width: "100%", marginTop: "10px", display: "flex", gap: "10px" }}>
                  <SearchComponent
                    style={{ width: "200px" }}
                    placeHolder="Search Unique ID"
                    onChange={(e) => getData({ query: e.target.value })}
                  />
                  <Button
                    style={{ backgroundColor: 'green', color: 'white' }}
                    className="ml-1"
                    shape="round"
                    type="default"
                    icon={<SaveOutlined />}
                    onClick={handleSaveData}
                  >
                    Save
                  </Button>
                  <Button
                    icon={<SearchOutlined />}
                    className="primary-btn ml-1"
                    shape="round"
                    type="primary"
                    onClick={() => setSearchModal(true)}
                  >
                    Search Filter
                  </Button>

                  {clearData && (
                    <Button
                      className="btn-danger"
                      shape="round"
                      icon={<ReloadOutlined />}
                      onClick={clearFilterData}
                    >
                      Clear Filters
                    </Button>
                  )}
                  <Button
                    style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<DeleteOutlined />}
                    onClick={handleDeleteUniueID}
                  >
                    Delete  Unique ID Boxes
                  </Button>
                  <Button
                    className='primary-btn'
                    // style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<EyeFilled />}
                    onClick={() => setDeleteModalVisible(true)}
                  >
                    View Deleted Unique ID Boxes
                  </Button>
                </div>

                {/* Search Modal */}
                <Modal
                  open={searchModal}
                  onCancel={() => setSearchModal(false)}
                  onOk={handleSearch}
                  okText="Search"
                  title={
                    <span>
                      Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                      <hr />
                    </span>
                  }
                  width={600}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>
                        Search by Spec or Customer
                      </label>
                      <Input
                        placeholder="Enter Spec or Customer Name"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Pickup Date</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        placeholder="Select Pickup Date"
                        value={searchDate}
                        onChange={(date) => setSearchDate(date)}
                        format="MM/DD/YYYY"
                      />
                    </div>
                  </div>
                </Modal>

                {/* File Modal */}
                <Modal open={fileModal} onCancel={handleClose} width={700} footer={null}>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                    <Button
                      className="primary-btn"
                      onClick={() => {
                        setAddFileModal(true);
                        setFileValue('file_type', '');
                      }}
                    >
                      Add File Type
                    </Button>
                  </div>
                  <TableComponent
                    columns={role_id == 1 || role_id == 2 ? fileTypeColumns : ''}
                    dataSource={tableFileData}
                    TotalDataCount={counts}
                    size={'small'}
                    onChangeDispatch={getData}
                  />
                </Modal>
              </Flex>
            }

          />

          {prepQueueByIdData.length > 0 ? (
            <>
              <Form form={form} component={false}>
                <TableComponent
                  rowSelection={rowSelection}
                  dataSource={
                    activetab === '1'
                      ? preprocessingQueueData
                      : completedPreprocessingQueueData
                  }
                  columns={columns}
                  onChangeDispatch={(payload) => {
                    getData(payload);
                    handleSaveData(payload, 'pagination');
                  }}
                />
              </Form>
            </>
          ) : (
            <>
              <TableComponent
                rowSelection={rowSelection}

                columns={columns}
              />
            </>
          )}

        </TabPane>
        <TabPane tab="Spec Assigned Boxes" key="2">
          <Card
            // title="Add Box To Spec"
            extra={
              <Flex justify="space-between" align="center" style={{ width: "100%", flexWrap: "wrap", marginTop: '20px' }}>
                <div>
                  <Button
                    style={{ backgroundColor: '#1e90a9' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<PrinterOutlined />}
                    onClick={handleDownloadBarcodeExcel}
                  >
                    Export Unique ID Label
                  </Button>

                  <Button
                    style={{ backgroundColor: '#da7e22ff' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={handleDownloadExcel}
                  >
                    Download Template
                  </Button>

                  <Button
                    style={{ backgroundColor: '#7e0e0eff' }}
                    className="ml-2"
                    shape="round"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => showModal()}
                  >
                    Upload Excel
                  </Button>



                  {role_id != 3 && (
                    <Button
                      style={{ backgroundColor: '#96743e', color: 'white' }}
                      icon={<FileOutlined />}
                      className="rounded-5 ml-1"
                      onClick={() => setFileModal(true)}
                    >
                      Document File Types
                    </Button>
                  )}
                </div>

                {/* Second line with Search + Clear */}
                <div style={{ width: "100%", marginTop: "10px", display: "flex", gap: "10px" }}>
                  <SearchComponent
                    style={{ width: "200px" }}
                    placeHolder="Search Unique ID"
                    onChange={(e) => getData({ query: e.target.value })}
                  />
                  <Button
                    style={{ backgroundColor: 'green', color: 'white' }}
                    className="ml-1"
                    shape="round"
                    type="default"
                    icon={<SaveOutlined />}
                    onClick={handleSaveData}
                  >
                    Save
                  </Button>
                  <Button
                    icon={<SearchOutlined />}
                    className="primary-btn ml-1"
                    shape="round"
                    type="primary"
                    onClick={() => setSearchModal(true)}
                  >
                    Search Filter
                  </Button>

                  {clearData && (
                    <Button
                      className="btn-danger"
                      shape="round"
                      icon={<ReloadOutlined />}
                      onClick={clearFilterData}
                    >
                      Clear Filters
                    </Button>
                  )}
                  <Button
                    style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<DeleteOutlined />}
                    onClick={handleDeleteUniueID}
                  >
                    Delete Box Unique ID
                  </Button>
                  <Button
                    className='primary-btn'
                    // style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<EyeFilled />}
                    onClick={() => setDeleteModalVisible(true)}
                  >
                    View Delete Unique ID Boxes
                  </Button>
                </div>

                {/* Search Modal */}
                <Modal
                  open={searchModal}
                  onCancel={() => setSearchModal(false)}
                  onOk={handleSearch}
                  okText="Search"
                  title={
                    <span>
                      Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                      <hr />
                    </span>
                  }
                  width={600}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>
                        Search by Spec or Customer
                      </label>
                      <Input
                        placeholder="Enter Spec or Customer Name"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Pickup Date</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        placeholder="Select Pickup Date"
                        value={searchDate}
                        onChange={(date) => setSearchDate(date)}
                        format="MM/DD/YYYY"
                      />
                    </div>
                  </div>
                </Modal>

                {/* File Modal */}
                <Modal open={fileModal} onCancel={handleClose} width={700} footer={null}>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                    <Button
                      className="primary-btn"
                      onClick={() => {
                        setAddFileModal(true);
                        setFileValue('file_type', '');
                      }}
                    >
                      Add File Type
                    </Button>
                  </div>
                  <TableComponent
                    columns={role_id == 1 || role_id == 2 ? fileTypeColumns : ''}
                    dataSource={tableFileData}
                    TotalDataCount={counts}
                    size={'small'}
                    onChangeDispatch={getData}
                  />
                </Modal>
              </Flex>
            }
          />

          {completedPrepQueueByIdData.length > 0 ? (
            <>
              <Form form={form} component={false}>
                <TableComponent
                  rowSelection={rowSelection}
                  dataSource={
                    activetab === '1'
                      ? preprocessingQueueData
                      : completedPreprocessingQueueData
                  }
                  columns={completedcolumns}
                  onChangeDispatch={(payload) => {
                    getData(payload);
                    handleSaveData(payload, 'pagination');
                  }}
                />
              </Form>
            </>
          ) : (
            <>
              <TableComponent
                rowSelection={rowSelection}

                columns={completedcolumns}
              />
            </>
          )}

        </TabPane>
      </Tabs>
      <Modal open={addFileMOdal}
        onCancel={handleAddFileClose}
        onOk={handleAddFileSubmit}
        title={
          <>
            {isEditingFile ? "Edit File Type" : "Add File Type"}{" "}
            <span style={{ color: "red" }}>*</span>
          </>
        } >
        <form onSubmit={handleFileSubmit(onSubmitFile)}>
          <Row gutter={[10, 0]} wrap className="p-2">
            <Col span={12}>
              <Controller
                name="file_type"
                control={fileControl}
                render={({ field }) => (
                  <Input
                    ref={inputRef}
                    autoFocus
                    {...field}
                    placeholder="Enter File Type"

                  />
                )}
              />
              {fileErrors.file_type && (
                <p style={{ color: 'red' }}>{fileErrors.file_type.message}</p>
              )}
            </Col>
          </Row>
        </form>
      </Modal>

      <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
        <Upload
          beforeUpload={(file) => {
            setFileList([file]);
            return false;
          }}
          fileList={fileList}
          accept=".xlsx, .xls"
        >
          <Button icon={<UploadOutlined />}>Select Excel File</Button>
        </Upload>
      </Modal>
      {prepTeamQueueLoading ? <Loader /> : <>
        <Modal
          title="Upload in Progress"
          open={uploadModalVisible}
          footer={[
            <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log")}>
              Go to Upload Logs
            </Button>,
          ]}
          onCancel={() => setUploadModalVisible(false)}
        >
          <p>Data upload is in progress. Please check upload logs.</p>
        </Modal>
      </>}

      <Modal
        open={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={null}
        width={1000}
        bodyStyle={{
          padding: "20px 24px",
          borderRadius: "12px",
          background: "#fafafa",
        }}
        style={{
          borderRadius: "12px",
        }}
      >
        {/* Header Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <DeleteOutlined style={{ fontSize: 20, color: "#ff4d4f" }} />
            <Title
              level={4}
              style={{ margin: 0, color: "#333", fontWeight: 600, letterSpacing: 0.3 }}
            >
              Deleted Unique ID Boxes
            </Title>
          </div>
        </div>

        <Divider style={{ margin: "12px 0" }} />

        {/* Table Section */}
        <div
          style={{
            maxHeight: 400,
            overflowY: "auto",
            borderRadius: "8px",
            background: "#fff",
            padding: "8px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <TableComponent
            columns={deletedColumns}
            dataSource={deletedTableData}
            TotalDataCount={deletedCounts}
          />
        </div>
      </Modal>;

    </>
  );
};

export default App;